import { Installation, InstallationCore } from '../types/installation';

/*
  Function to convert an entire text string to lowercase, 
  ignoring numbers and special characters and then converting 
  the first letter of each word to uppercase.
*/
export function formatName(name: string) {
  return name.toLowerCase().replace(/\b[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ]+/g, (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
}

export const getPolicyClientName = (installation: Installation) => {
  let client = '';
  if (installation.poliza) {
    const { contratante, conductorHabitual } = installation.poliza;
    if (contratante?.razonSocial) return contratante?.razonSocial;
    else if (contratante.nombre) client = `${contratante.nombre} ${contratante.apePaterno} ${contratante.apeMaterno}`;
    else if (conductorHabitual)
      client = `${conductorHabitual.nombre} ${conductorHabitual.apePaterno} ${conductorHabitual.apeMaterno}`;
  }
  return formatName(client);
};

export const splitFullName = (fullName: string): { name: string; lastName: string; motherName: string } => {
  const formattedName = formatName(fullName);
  const parts = formattedName.trim().split(/\s+/);
  if (parts.length === 0) {
    return { name: '', lastName: '', motherName: '' };
  }
  if (parts.length === 1) {
    return { name: parts[0], lastName: '', motherName: '' };
  }
  if (parts.length === 2) {
    return { name: parts[0], lastName: parts[1], motherName: '' };
  }
  return {
    name: parts.slice(0, -2).join(' '),
    lastName: parts[parts.length - 2],
    motherName: parts[parts.length - 1],
  };
};

export const getInstallationClient = (installation: InstallationCore, withLabel: boolean = true) => {
  const { label, clientName, contratante } = installation;
  if (clientName && label && withLabel) {
    return `${clientName} (${label})`;
  }
  return clientName || contratante;
};
